import logo from './logo.svg';
import './App.css';
import { Route, Routes } from 'react-router-dom';
import Navbar from './Pages/Navbar/Navbar';
import Hero from './Pages/Hero/Hero';
import About from './Pages/About/About';
import Footer from './Pages/Footer/Footer';
import Privacy from './Pages/PrivacyPolicy/Privacy';
import ScrollToTop from './Pages/ScrollToTop/ScrollToTop';

function App() {
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Hero />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy-policy" element={<Privacy />} />
      </Routes>
      <Footer />
      <ScrollToTop />
    </>
  );
}

export default App;
